import { render } from "./CapFourIcon.vue?vue&type=template&id=6edf9b4a&scoped=true"
import script from "./CapFourIcon.vue?vue&type=script&lang=js"
export * from "./CapFourIcon.vue?vue&type=script&lang=js"

import "./CapFourIcon.vue?vue&type=style&index=0&id=6edf9b4a&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/webtool/www-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6edf9b4a"]])

export default __exports__